import { NgModule } from '@angular/core';
import { LibStarIconComponent } from './lib-star-icon.component';

@NgModule({
  declarations: [LibStarIconComponent],
  exports: [LibStarIconComponent],
})
export class LibStarIconModule {}
